const createPlanProgressUrlBySlug = (slug, lang) =>
    lang === 'eu' ? `${slug}/aurrerapena` : `${slug}/progreso`

export default createPlanProgressUrlBySlug